import React from 'react';
import classnames from 'classnames';

import { can } from '../can';
import { routes } from '../routes';
import { getCountryName } from '../utils/index';

import api from '../utils/api';
import { useQuery } from '../utils/query';

import { lockerStatusLabels, lockerStatusColors, lockerConnectionLabels, lockerConnectionColors, doorTypeLabels } from '../constants';

import PageHeader from '../components/common/PageHeader';
import Pagination from '../components/common/Pagination';
import Button from '../components/common/Button';
import Toggle from '../components/common/Toggle';
import Link from '../components/common/Link';

import { List, Header, Body, Row, Cell } from '../components/common/List';
import { modeLabels } from '../constants';

import { Loading } from './PageStatus';

import css from './Lockers.css';

export const Lockers = (props) => {
  const query = useQuery(props.location, props.history);
  const { user } = api.auth();
  const { index, actions } = api.lockers.index(query.obj);

  return (
    <main className={css.root}>
      <PageHeader title="Lockers">
        {can(user, 'create', 'lockers') && (
          <Button noMargin to={routes('newLocker')}>
            Nuevo
          </Button>
        )}
      </PageHeader>
      <div className={css.toolBar}>
        <Toggle
          label="Solo lockers activos"
          onChange={(n, chk) => query.set(n, chk ? 'active' : null)}
          name={'status'}
          value={query.get('status') || false}
        />
        <Toggle
          label="Solo lockers online"
          onChange={(n, chk) => query.set(n, chk ? true : false)}
          name={'online'}
          value={query.get('online') == 'true' || query.get('online') || false}
        />
      </div>
      {index.loaded ? (
        <List className={css.root}>
          <Header>
            <Cell head>ID</Cell>
            <Cell head>Nombre</Cell>
            <Cell head>Modo - Tipo</Cell>
            <Cell head>Ubicación</Cell>
            <Cell head>País</Cell>
            <Cell head>Puertas</Cell>
            <Cell head>Estado</Cell>
            <Cell head>Conexión</Cell>
          </Header>
          <Body>
            {index.data.toJS().map((locker, index) => {
              const to = routes('locker', { id: locker.id });
              const isUnregistered = locker.status == 'unregistered';
              const prefs = locker.preferences || {};

              const labelClass = {
                [css['border-warning']]: prefs.mode === 'housing',
                [css['border-purple']]: prefs.mode === 'custody',
                [css['border-enabled']]: prefs.mode !== 'housing' && prefs.mode !== 'custody',
              }
              const country = getCountryName(locker.locationCountryCode);
              const doors = locker.doorsInfo.find((r) => r.status == 'active') || {};
              const doorsAvailable = doors.doorsTotal - doors.doorsReserved - doors.doorsOccupied;
              const reservationCapacity = prefs.enableUnlimitedReservations ? 'Ilimitada' : doors.doorsTotal - doors.doorsOccupied - doors.doorsReserved;
              const doorsReservedMessage = doors.doorsReserved ? `${doors.doorsReserved} / ${reservationCapacity} Reservadas` : 'Sin reservas';
              const modeLabel = modeLabels(prefs.mode) || modeLabels('normal');
              const doorTypeLabel = doorTypeLabels(prefs.doorType) || doorTypeLabels('serial');

              return (
                <Row key={`lockers-row-${index}`}>
                  <Cell>
                    <Link to={to}>{locker.id}</Link>
                  </Cell>
                  <Cell className={css.name}>
                    <Link to={to}>{locker.name}</Link>
                  </Cell>
                  <Cell>
                    <Cell>
                      <Link to={to}>
                        {prefs.mode ? (
                          <span
                            className={classnames(css.optionType, labelClass)}
                            title={modeLabels(prefs.mode)}
                          >
                            {`${modeLabel}${doorTypeLabel ? ` - ${doorTypeLabel}` : ''}`}
                          </span>
                        ) : (
                          <span
                            className={classnames(css.optionType, css['border-enabled'])}
                            title={modeLabels('normal')}
                          >
                            {`${modeLabel}${doorTypeLabel ? ` - ${doorTypeLabel}` : ''}`}
                          </span>
                        )}
                      </Link>
                    </Cell>
                  </Cell>
                  <Cell>{locker.locationName}</Cell>
                  <Cell>{country}</Cell>
                  <Cell>
                    {doors.doorsTotal ? (
                      <>
                        <small>
                          {doorsAvailable}/{doors.doorsTotal} Disponibles
                        </small>
                        <div
                          className={css.usageBar}
                          style={{
                            width: 100,marginBottom: 5,
                          }}>
                          <div
                            className={css.inner}
                            style={{
                              width: (100 * doorsAvailable) / doors.doorsTotal,
                            }}
                          />
                        </div>
                        <small>{doorsReservedMessage}</small> 
                        <small>{doors.doorsOccupied} Ocupadas</small>

                      </>
                    ) : (
                      <small>{'Sin puertas creadas'}</small>
                    )}
                  </Cell>
                  <Cell
                    style={{
                      width: 100,
                      color: lockerStatusColors(locker.status),
                    }}
                    className={css.status}>
                    {lockerStatusLabels(locker.status)}
                  </Cell>
                  <Cell>
                    <span
                      className={css.dot}
                      style={{
                        backgroundColor: lockerConnectionColors(
                          isUnregistered ? 'unregistered' : locker.online ? 'online' : 'offline'
                        ),
                      }}
                    />
                    {locker.status == lockerConnectionLabels(locker.online ? 'online' : 'offline')}
                  </Cell>
                </Row>
              );
            })}
          </Body>
        </List>
      ) : index.loading ? (
        <Loading compact />
      ) : (
        <p>{index.error}</p>
      )}
      {index.pageInfo && <Pagination {...index.pageInfo.toJS()} onChange={query.setPage} />}
    </main>
  );
};

export default Lockers;
